import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta04Model } from './model-consultaSeguimentoPergunta04'
import { isPergunta04GostaDeSubirEmAllNao } from './utils-consultaSeguimentoPergunta04'

export const PERGUNTA_04_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta04Model> = {
  PERGUNTA_04_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_04_GOSTA_DE_SUBIR_EM',
      },
    ],
  },
  PERGUNTA_04_GOSTA_DE_SUBIR_EM: {
    scrollConditions: [
      {
        if: (value) => hasAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => isPergunta04GostaDeSubirEmAllNao(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_04_HEADER',
  },
}
